const REQUEST_PATHS = {
  prd: "https://accounts.dmm.com/settings/premium",
  stg: "https://stg-accounts.dmm.com/settings/premium",
  dev: "https://stg-accounts.dmm.com/settings/premium",
  lab: "https://stg-accounts.dmm.com/settings/premium",
  local: "https://stg-accounts.dmm.com/settings/premium",
} as const;

export const URL = {
  top: "https://www.dmm.com",
  help: "https://help.dmm.com/",
  coupon: "https://coupon.dmm.com/",
  /*
   * DMMTV側からfanzaへ遷移する際cookieが引き継げずセッションが切れるためmemcachedサーバーを経由させる必要があるため
   * /service/-/exchange/=/?url= を付与している
   *参考: https://confl.arms.dmm.com/display/PFLDG/Cookie+exchange
   */
  fanza: "https://www.dmm.com/service/-/exchange/=/?url=https%3A%2F%2Fwww.dmm.co.jp%2Ftop%2F",
  pointClub: "https://www.pointclub.dmm.com/",
  pointCharge: "https://point.dmm.com/choice/pay?basket_service_type=dmmtv&dark_theme=1",
  /** memo: (okita) このURLの最後にdata-link.svg を付与すると画像を取得できる*/
  baseSvg: "https://p-smith.com/service-icon/",
  login: process.env.NEXT_PUBLIC_LOGIN_ENDPOINT,
  logout: process.env.NEXT_PUBLIC_LOGOUT_ENDPOINT,
  register: process.env.NEXT_PUBLIC_REGISTER_ENDPOINT,
  contractInfo: REQUEST_PATHS[process.env.BUILD_MODE],
} as const;
